import { z } from 'zod';

/**
 * Zod Schema für Block — Runtime-Validierung + Type-Inference.
 * Sperren mit Zeitraum. endsAt = null bedeutet permanente Sperre.
 */
export const BlockSchema = z.object({
  id: z.string().cuid(),
  userId: z.string(),
  reason: z.string(),
  blockedBy: z.string(), // User ID des Admins
  startsAt: z.coerce.date(),
  endsAt: z.coerce.date().nullable().optional(), // null = permanent
  isActive: z.boolean().default(true),
  createdAt: z.coerce.date(),
});

/** TypeScript Type — abgeleitet aus dem Zod Schema */
export type Block = z.infer<typeof BlockSchema>;

/**
 * Schema für Block-Erstellung.
 */
export const CreateBlockSchema = BlockSchema.pick({
  userId: true,
  reason: true,
  blockedBy: true,
  startsAt: true,
  endsAt: true,
});

/** TypeScript Type für Block-Erstellung */
export type CreateBlock = z.infer<typeof CreateBlockSchema>;

/**
 * Schema für Block-Update.
 * Alle Felder optional — PATCH-Semantik.
 */
export const UpdateBlockSchema = BlockSchema.pick({
  reason: true,
  endsAt: true,
  isActive: true,
}).partial();

/** TypeScript Type für Block-Update */
export type UpdateBlock = z.infer<typeof UpdateBlockSchema>;
